if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
console.log('RECENTLY VIEWED JS v2.1 LOADED');
      const searchUrl = (window.theme?.routes?.search_url || '/search');

      this.url = searchUrl + '?view=recently-viewed&type=product&q=';
      this.currentHandle = this.dataset.productHandle;
      this.max = parseInt(this.dataset.max || 4, 10);
      this.products = '';

      // Find swiper wrapper where slides must be injected
      this.wrapper = this.closest('.product-carousel')
        ?.querySelector('.swiper-wrapper');

      // Load recently viewed handles from localStorage
      const recentIds = localStorage.getItem('recently-viewed');
      this.recentIds = recentIds ? JSON.parse(recentIds) : [];
    }

    connectedCallback() {
      // No wrapper or no recently viewed data → hide whole section
      if (!this.wrapper || !this.recentIds.length) {
        this.hideSection();
        return;
      }

      this.buildUrl();
    }

    buildUrl() {
      let i = 0;

      this.recentIds.forEach(handle => {
        // Skip current product
        if (handle === this.currentHandle) return;

        // Stop at max items
        if (i >= this.max) return;

        this.products += 'handle:' + handle + ' OR ';
        i++;
      });

      // Nothing usable hide section
      if (!this.products) {
        this.hideSection();
        return;
      }

      this.url += encodeURIComponent(this.products);
      this.fetchProducts();
    }

    fetchProducts() {
  fetch(this.url)
    .then(r => r.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;

      const fetchedSlides = Array.from(
        html.querySelectorAll('.swiper-slide')
      );

      //No usable slides or only 1 → hide entire section
      if (!fetchedSlides.length || fetchedSlides.length < 1) {
        this.hideSection();
        return;
      }

      //Reorder slides to match localStorage order
      const orderedSlides = [];

      this.recentIds.forEach(handle => {
        if (handle === this.currentHandle) return;

        const match = fetchedSlides.find(slide =>
          slide.innerHTML.includes(`/products/${handle}`) ||
          slide.dataset?.handle === handle
        );

        if (match) orderedSlides.push(match);
      });

      if (orderedSlides.length < 1) {
        this.hideSection();
        return;
      }

      //Inject slides in correct order
      orderedSlides.forEach(slide =>
        this.wrapper.appendChild(slide)
      );

      this.classList.add('product-recommendations--loaded');
      this.refreshSwiper();
    })
    .catch(e => {
      console.error('Recently viewed error:', e);
      this.hideSection();
    });
}


    refreshSwiper() {
      const swiperEl = this.closest('.product-carousel')
        ?.querySelector('.product-carousel-swiper');

      if (!swiperEl) return;

      // Fully destroy existing swiper (empty-on-init bug fix)
      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      // Recreate swiper (mirrors SELECT carousel behavior)
      const slidesPerViewDesktop = parseInt(this.wrapper?.dataset.count, 10) || 4;
      const slidesPerViewMobile = parseInt(this.wrapper?.dataset.countMobile, 10) || 2;
      const perView = n => Math.min(n, slidesPerViewDesktop);

      new Swiper(swiperEl, {
        slidesPerView: slidesPerViewDesktop,
        spaceBetween: 20,
        navigation: {
          nextEl: swiperEl.closest('.product-carousel')
            .querySelector('.carousel__button-next'),
          prevEl: swiperEl.closest('.product-carousel')
            .querySelector('.carousel__button-prev')
        },
        // Same steps as product-carousel.js so cards stay a readable width
        breakpoints: {
          0: { slidesPerView: slidesPerViewMobile },
          750: { slidesPerView: perView(3) },
          1200: { slidesPerView: perView(4) },
          1360: { slidesPerView: perView(5) },
          1600: { slidesPerView: perView(6) }
        }
      });
    }

    hideSection() {
      // Hide the entire Shopify section (title, spacing, arrows, everything)
      const section = this.closest('section');
      if (!section) return;

      section.style.display = 'none';
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
